export const NamePlaceholder = "Untitled Action Set";

export const TriggerDurations = [ 10, 15, 30, 60 ];// { SHORTEST: 10, SHORT: 15, LONG: 30, LONGEST: 60 };
export const TriggerThresholds = [ 0, 2, 5, 10, 15, 30 ];// { SHORTEST: 0, SHORT: 10, LONG: 15, LONGEST: 30 };
export const DwellDurations = [ 5, 10, 15, 30 ];
